import {Box, CircularProgress} from "@mui/material";
import {useLocation} from "react-router-dom";
import M2MTokenForm from "../components/M2MTokens/M2MTokenForm";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";

const M2MTokenDetail = () => {
  const {state} = useLocation();
  const id = state?.id;

  const {data, loading, read} = useApiRequest({baseUrl: `/m2m-tokens`, resource: "m2mTokens"});

  return (
    <>
      <Window title={"Nuevo Token M2M"} backTo="/m2m-tokens">
        {loading ? (
          <CircularProgress />
        ) : (
          <Box>
            <Box sx={{display: "flex", gap: 2}}>
              <M2MTokenForm
                refreshData={() => read(id)}
                initialTokenData={data}
              />
            </Box>
          </Box>
        )}
      </Window>
    </>
  );
};

export default M2MTokenDetail;
